import { render, staticRenderFns } from "./AddBatchModal.vue?vue&type=template&id=50b875a8&scoped=true&"
import script from "./AddBatchModal.vue?vue&type=script&lang=js&"
export * from "./AddBatchModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBatchModal.vue?vue&type=style&index=0&id=50b875a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b875a8",
  null
  
)

export default component.exports